import { t } from "@/i18n-js/instance";
import { toLocaleString } from "@circle-react/helpers/number";
import { Icon } from "@circle-react-shared/Icon";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { Typography } from "@circle-react-uikit/Typography";

interface BillingDetailsHeaderProps {
  currencySymbol: string;
  finalOveragePrice?: number;
  isOverage: boolean;
  priceOverage?: number;
}

export const BillingDetailsHeader = ({
  finalOveragePrice,
  currencySymbol,
  isOverage,
  priceOverage,
}: BillingDetailsHeaderProps) => (
  <div className="mb-1 flex justify-between">
    <div className="flex items-center gap-2">
      <Typography.TitleSm weight="bold" data-testid="plan-name">
        {t("settings.billing.ai_actions.product_name")}
      </Typography.TitleSm>
    </div>
    {isOverage && finalOveragePrice && priceOverage && (
      <div className="flex items-center">
        <Typography.TitleSm weight="bold" data-testid="plan-price">
          {`${currencySymbol}${toLocaleString(finalOveragePrice)}`}
        </Typography.TitleSm>
        <TippyV2
          content={t("settings.billing.ai_actions.overage_tooltip", {
            price: `${currencySymbol}${toLocaleString(priceOverage)}`,
          })}
        >
          <Icon
            type="16-info"
            useWithStrokeCurrentColor
            size={16}
            className="ml-1"
          />
        </TippyV2>
      </div>
    )}
  </div>
);
